import {useEffect, useState} from 'react';
import '../style/css/test.css'
const TableApp = () => {
    const [tables, setTables] = useState([
        { id: 1, name: 'Table 1', x: 100, y: 100, maxPeople: 4, shape: 'circle' },
        { id: 2, name: 'Table 2', x: 300, y: 200, maxPeople: 6, shape: 'rectangle' },
    ]);
    const [selectedTable, setSelectedTable] = useState(null);
    const [action, setAction] = useState(null);
    const [dragging, setDragging] = useState(null);

    // Add new table handler
    const handleAddTable = (newTable) => {
        const id = Math.random().toString(36).slice(2, 11); // Improved ID generation
        setTables(prev => [...prev, { ...newTable, id, x: 300, y: 300 }]);
    };

    const handleMouseDown = (id, e) => {
        setDragging({
            id,
            offsetX: e.clientX - tables.find(t => t.id === id).x,
            offsetY: e.clientY - tables.find(t => t.id === id).y
        });
    };

    const handleMouseMove = (e) => {
        if (!dragging) return;

        const newTables = tables.map(table => {
            if (table.id === dragging.id) {
                return {
                    ...table,
                    x: e.clientX - dragging.offsetX,
                    y: e.clientY - dragging.offsetY
                };
            }
            return table;
        });

        setTables(newTables);
    };

    const handleMouseUp = () => {
        setDragging(null);
    };

    const handleTableClick = (tableId, e) => {
        e.stopPropagation();
        setSelectedTable(tableId);
    };

    const handleAction = (actionType) => {
        setAction(actionType);
    };

    const handleCloseModal = () => {
        setAction(null);
        setSelectedTable(null);
    };

    return (
        <div
            className="app"
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onClick={() => setSelectedTable(null)}
        >
            <h1>Restaurant Table Layout</h1>
            <button className="add-button" onClick={() => setAction('add')}>
                Add New Table
            </button>
            <div className="tables-container">
                {tables.map(table => (
                    <div
                        key={table.id}
                        className={`table ${table.shape} ${selectedTable === table.id ? 'selected' : ''}`}
                        style={{
                            left: `${table.x}px`,
                            top: `${table.y}px`,
                            cursor: dragging?.id === table.id ? 'grabbing' : 'grab'
                        }}
                        onMouseDown={(e) => handleMouseDown(table.id, e)}
                        onClick={(e) => handleTableClick(table.id, e)}
                    >
                        <div className="table-info">
                            <h3>{table.name}</h3>
                            <p>Max: {table.maxPeople}</p>
                        </div>
                    </div>
                ))}
            </div>

            {selectedTable && (
                <div className="action-menu" style={{
                    left: tables.find(t => t.id === selectedTable).x + 20,
                    top: tables.find(t => t.id === selectedTable).y + 20
                }}>
                    <button onClick={() => handleAction('edit')}>Edit</button>
                    <button onClick={() => handleAction('delete')}>Delete</button>
                    <button onClick={() => handleAction('reserve')}>Reserve</button>
                    <button onClick={() => handleAction('info')}>Info</button>
                </div>
            )}

            {action && (
                <div className="modal-overlay">
                    <div className="modal">
                        {action === 'edit' && (
                            <EditModal
                                table={tables.find(t => t.id === selectedTable)}
                                onSave={(updated) => {
                                    setTables(prevTables =>
                                        prevTables.map(t => t.id === selectedTable ? updated : t)
                                    );
                                    handleCloseModal();
                                }}
                                onClose={handleCloseModal}
                            />
                        )}
                        {action === 'delete' && (
                            <DeleteModal
                                onConfirm={() => {
                                    setTables(tables.filter(t => t.id !== selectedTable));
                                    handleCloseModal();
                                }}
                                onClose={handleCloseModal}
                            />
                        )}
                        {action === 'reserve' && (
                            <ReserveModal
                                maxPeople={tables.find(t => t.id === selectedTable).maxPeople}
                                onClose={handleCloseModal}
                            />
                        )}
                        {action === 'info' && (
                            <InfoModal
                                table={tables.find(t => t.id === selectedTable)}
                                onClose={handleCloseModal}
                            />
                        )}
                        {action === 'add' && (
                            <div className="modal-overlay">
                                <div className="modal">
                                    <AddTableModal
                                        onSave={handleAddTable}
                                        onClose={() => setAction(null)}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

// Modal Components
const EditModal = ({table, onSave, onClose}) => {
    const [formData, setFormData] = useState({...table});

    useEffect(() => {
        setFormData({...table}); // Update form data when table changes
    }, [table]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);  // Save first
        onClose();         // Then close
    };
    return (
        <div>
            <h2>Edit Table</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    Name:
                    <input
                        value={formData.name}
                        onChange={e => setFormData({...formData, name: e.target.value})}
                    />
                </label>
                <label>
                    Max People:
                    <input
                        type="number"
                        value={formData.maxPeople}
                        onChange={e => setFormData({...formData, maxPeople: parseInt(e.target.value)})}
                    />
                </label>
                <label>
                    Shape:
                    <select
                        value={formData.shape}
                        onChange={e => setFormData({...formData, shape: e.target.value})}
                    >
                        <option value="circle">Circle</option>
                        <option value="rectangle">Rectangle</option>
                    </select>
                </label>
                <div className="modal-actions">
                    <button type="submit">Save</button>
                    <button type="button" onClick={onClose}>Cancel</button>
                </div>
            </form>
        </div>
    );
};

const DeleteModal = ({ onConfirm, onClose }) => (
    <div>
        <h2>!@@@@!!!!!!!2$מחיקת שולחן</h2>
        <p>Are you sure you want to delete this table?</p>
        <div className="modal-actions">
            <button onClick={onConfirm}>Delete</button>
            <button onClick={onClose}>Cancel</button>
        </div>
    </div>
);

const ReserveModal = ({ maxPeople, onClose }) => {
    const [people, setPeople] = useState(0);

    return (
        <div>
            <h2>שמור שולחן!*!!!!*!</h2>
            <label>
                Number of people (max {maxPeople}):
                <input
                    type="number"
                    value={people}
                    min="0"
                    max={maxPeople}
                    onChange={e => setPeople(Math.min(maxPeople, e.target.value))}
                />
            </label>
            <div className="modal-actions">
                <button onClick={onClose}>Reserve</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </div>
    );
};

const InfoModal = ({ table, onClose }) => (
    <div>
        <h2>Table Information</h2>
        <p>Name: {table.name}</p>
        <p>Capacity: {table.maxPeople}</p>
        <p>Shape: {table.shape}</p>
        <p>Position: ({table.x}, {table.y})</p>
        <div className="modal-actions">
            <button onClick={onClose}>Close</button>
        </div>
    </div>
);
const AddTableModal = ({ onSave, onClose }) => {
    const [formData, setFormData] = useState({
        name: 'New Table',
        maxPeople: 4,
        shape: 'rectangle'
    });
    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);  // This should come first
        onClose();         // Close modal after saving
    };
    return (
        <div>
            <h2>Add New Table</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    Name:
                    <input
                        value={formData.name}
                        onChange={e => setFormData({...formData, name: e.target.value})}
                    />
                </label>
                <label>
                    Max People:
                    <input
                        type="number"
                        value={formData.maxPeople}
                        onChange={e => setFormData({...formData, maxPeople: parseInt(e.target.value) || 0})}
                    />
                </label>
                <label>
                    Shape:
                    <select
                        value={formData.shape}
                        onChange={e => setFormData({...formData, shape: e.target.value})}
                    >
                        <option value="circle">Circle</option>
                        <option value="rectangle">Rectangle</option>
                        <option value="square">Square</option>
                    </select>
                </label>
                <div className="modal-actions">
                    <button type="submit">Create</button>
                    <button type="button" onClick={onClose}>Cancel</button>
                </div>
            </form>
        </div>
    );
};

export default TableApp;
